export default{

    water: 'Νερό',
    noListings: 'Καμία καταγραφή αυτή την ημέρα',
    feelings: 'Συναισθήματα',
    meals: 'Καταγραφές γευμάτων',
}
